module.exports = __webpack_public_path__ + "img/blackhole-m.14d94424.png";